import React, { useState, useEffect } from 'react';
import { Container, Grid, Tab, AppBar, Paper } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

import { OTT } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import { OTTTransactionBundle } from 'Pages/InnerPages/OTT/Paysprint/Web/OTTTransactionBundle';
import { OTTTransactionSubscription } from 'Pages/InnerPages/OTT/Paysprint/Web/OTTTransactionSubscription';

import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import OTTIcon from 'Components/DashboardIcon/OTTIcon';

import { useLocation } from 'react-router';
import { SelectAll as SERVICE_SELECT } from 'Components/Api/ServiceApi';

import { LOGOUT } from 'ConstComponents';
const CustomContainer = HOCLoader(Container);
const margin = {
    padding: '0px',
    paddingTop: '12px',
    marginLeft: '-24px'
};
export const OTTTransaction = ({ ServiceIDString }) => {
    const location = useLocation();
    const [value, setValue] = useState(OTT.toString());
    const [loadingOpen] = useState(false);
    const [responseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [Operator, setOperator] = useState([]);
    const [severity] = useState('success');

    const [refreshRandom, setRefreshRandom] = useState(1);
    const [Services, setServices] = useState([]);

    useEffect(() => {
        if (ServiceIDString !== undefined && ServiceIDString !== null) {
            setValue(ServiceIDString.toString());
        }
    }, [ServiceIDString]);

    useEffect(() => {
        let { state } = location;

        if (state === null) {
            return;
        }

        if (!state) return;
        let { ServiceID } = state;
        setValue(ServiceID);
    }, [location]);
    useEffect(() => {
        SelectServicesForDisplay();
    }, []);

    useEffect(() => {
        selectOperator(OTT);
    }, []);

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const SelectServicesForDisplay = async () => {
        const response = await SERVICE_SELECT();
        if (!response.isAuthorized) {
            LOGOUT();
        }

        var data = JSON.parse(response.data);
        setServices(data);
    };
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const isDisabled = (serviceCode) => {
        let isOff = false;

        Services.map((element) => {
            if (parseInt(element.ServiceID) === parseInt(serviceCode)) {
                isOff = !element.IsDisplay;
            }
        });

        if (isOff === true) {
            return { display: 'none' };
        }
        return { display: '' };
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginTop: '10px' }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TabContext value={value}>
                            <Paper square className="tabpanel">
                                <AppBar
                                    position="static"
                                    color="default"
                                    style={{
                                        height: '20',
                                        marginLeft: '20px'
                                    }}
                                >
                                    <TabList
                                        variant="scrollable"
                                        scrollButtons="on"
                                        onChange={handleChange}
                                        aria-label="simple tabs example"
                                        indicatorColor="primary"
                                        textColor="primary"
                                    >
                                        {Operator.map((operator, index) => (
                                            <Tab
                                                key={index}
                                                label={operator.OperatorName}
                                                icon={
                                                    <OTTIcon
                                                        serviceID={
                                                            operator.OperatorID
                                                        }
                                                        value={
                                                            operator.OperatorName
                                                        }
                                                    />
                                                }
                                                value={operator.OperatorName}
                                                style={isDisabled(OTT)}
                                            />
                                        ))}
                                    </TabList>
                                </AppBar>
                            </Paper>

                            {Operator.map((operator) => (
                                <TabPanel
                                    key={operator.OperatorName}
                                    value={operator.OperatorName}
                                >
                                    {operator.OperatorName === 'Bundle' && (
                                        <OTTTransactionBundle
                                            OperatorID={operator.OperatorID}
                                            setRefreshRandom={(value) => {
                                                setRefreshRandom(value);
                                            }}
                                        />
                                    )}
                                    {operator.OperatorName ===
                                        'Subscription' && (
                                        <OTTTransactionSubscription
                                            OperatorID={operator.OperatorID}
                                            setRefreshRandom={(value) => {
                                                setRefreshRandom(value);
                                            }}
                                        />
                                    )}
                                </TabPanel>
                            ))}
                        </TabContext>
                    </Grid>
                </Grid>
            </Grid>
        </CustomContainer>
    );
};
